import React, { useEffect, useState } from 'react'

import { ReactComponent as SearchIcon } from '../../../assets/icons/search.svg';
import { ReactComponent as CloseSearchIcon } from '../../../assets/icons/searchClose.svg';
import CenterModal from '../../../components/Modals/center-modal';
import { getBrokerCompanies } from '../../../services/private/site-visit.service';
import { getInitials } from '../../../helpers/helpers';
import { ReactComponent as CloseIcon } from '../../../assets/close.svg';

const SelectCompanyModal = ({ show, closeModal, setCompany, setComponentName }) => {
    const [searchText, setSearchText] = useState('');
    const [companyList, setCompanyList] = useState([]);

    const handleSearch = async () => {
        const res = await getBrokerCompanies(searchText);
        if (res.data.status === 200) {
            const list = res.data.data
                .filter(i => i.company_name)
            // .map(i => (
            //     {
            //         label: <div className='w-full flex justify-between text-sm sm:text-base'> <span>{i.company_name}</span> <span>{i.owner_name} ({i.owner_mobile})</span> </div>,
            //         value: i.id
            //     }
            // ))
            // return list;
            setCompanyList(list)
        }
    }

    useEffect(() => {
        handleSearch('')
    }, [searchText])

    console.log(companyList, 'companyList')
    return (
        <CenterModal show={show} closeModal={closeModal} modalClass='!max-w-[450px]  [&>*]:!border-0 [&>*]:!rounded-lg [&>*]:!overflow-hidden' backDropClassName={''}>
            <div className='!p-6'>
                <div className='flex justify-end'>
                    <button onClick={closeModal} className=''><CloseIcon /></button>
                </div>
                <label htmlFor="">Select Company</label>
                <div className={`flex w-100 !text-black700 rounded-lg !h-12 !px-4 py-2 !border items-center ${searchText ? '!border-primary' : 'border-grayLight   focus:!border-primary w-100 '}`}>
                    <div className=""><SearchIcon /></div>
                    <input
                        type="text"
                        className={` w-100  !ml-1 placeholder:!text-black700 focus:outline-0 `}
                        onChange={(e) => setSearchText(e.target.value)}
                        value={searchText}
                        placeholder={'Search and Select'}
                    />
                    {searchText && <button onClick={() => setSearchText('')}><CloseSearchIcon /></button>}
                </div>
                <div className='cursor-pointer flex items-center justify-center !mt-4' onClick={() => {
                    setComponentName('ownerNotify');
                    closeModal();
                }}>
                    <span className='text-base text-blue-900 font-semibold leading-9'>Couldn’t Find Your Company?</span>
                </div>
                {companyList.length > 0 && <div className='h-60 overflow-y-auto !mt-4'>
                    {companyList.map((item) => (
                        <div className='flex mb-2 cursor-pointer' onClick={() => {
                            setCompany(item);
                            closeModal();
                        }}>
                            <div className='h-12 w-12 text-base font-semibold flex items-center justify-center !text-blue-900 bg-blueHighlight rounded-lg !mr-4'>
                                {getInitials(item?.company_name)}
                            </div>
                            <div className='flex flex-col'>
                                <div>{item.company_name}</div>
                                <div>{item.owner_mobile}</div>
                            </div>
                        </div>
                    ))}
                </div>}
                {companyList.length === 0 && <p>No Result Found.</p>}
            </div>
        </CenterModal>
    )
}

export default SelectCompanyModal